/**
 * @module Support/customer-login
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
export const CUSTOMER_LOGIN_CONSTANTS = {
  HOME_PATH: '/home',
  ACCOUNT_LANDING_PATH: '/account-landing',
};
